// src/Pages/Incomes/IncomesIndex.jsx
import { useState } from "react";
import { Container, Typography, Box, Tabs, Tab, Paper, Card, CardContent, Grid } from "@mui/material";
import IncomesTable from "../../../Components/RME/Incomes/IncomesTable";
import IncomeStore from "../../../Components/RME/Incomes/IncomeStore";
import { TipodeIngresos } from "../../../Components/RME/Incomes/TypeIncomesFuncion";
import { BuscadorIncome } from "../../../Components/RME/Incomes/BuscadorIcome";
import "../../../Css/Paginas.css"
import Logocolor from "../../../Image/Logo.png";
import { TituloPrincipal } from "../../../Layouts/CustomStyles";
import { useGetIngresoCard } from "../../../Services/Incomes";
import { GiMoneyStack } from "react-icons/gi";
import { useGetSucursal } from "../../../Services/Sucursales";

function IncomesIndex() {
   const { sucursales } = useGetSucursal();
  const{ingreso,
    } = useGetIngresoCard();
    const [tab, setTab] = useState(0);
     const [refresh, setRefresh] = useState(false); 

    const obtenerNombreSucursal = (id) => {
    const suc = sucursales?.find(s => s.id === Number(id));
    return suc ? suc.name : "Sucursal desconocida";
};

     const getMonthName = (monthNumber) => {
  const months = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];
  return months[parseInt(monthNumber, 10) - 1] || "";
};

  const handleChange = (_, newValue) => setTab(newValue);
  return (
   <section className="FondoPagina">
      <Container maxWidth="xl" sx={{ mt: 4 }}>
         <Paper
                elevation={3}
                sx={{
                    p: 3,
                    backgroundColor: "#fff",
                    borderRadius: "16px",
                    minHeight: "70vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* 🔹 Título */}
                <Box sx={{display:"flex", justifyContent:'space-between'}}>
                <Box display="flex" alignItems="center" gap={2} mb={4}>
                    <img
                        src={Logocolor}
                        alt="Logo Clínica Activa"
                        style={{ width: 55, height: 55, objectFit: "contain" }}
                    />
                    <Typography variant="h5" sx={TituloPrincipal}>
                       Ingresos RME
                    </Typography>
                </Box>
        <Box mb={3} sx={{ display:'flex', justifyContent:'flex-end'}}>
          <IncomeStore onSuccess={() => setRefresh(prev => !prev)}/>
        </Box>
        </Box>
         <Box mt={5} mb={5}>
                            <Card
                                sx={{
                                    width: "50%",
                                    backgroundColor: "#ffffff",
                                    borderRadius: 3,
                                    boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                                    transition: "transform 0.2s, box-shadow 0.2s",
                                }}
                            >
                                <CardContent
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: "80%",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "flex-start",
                                            gap: 1,
                                        }}
                                    >
                                        <Typography
                                            variant="h4"
                                            fontWeight={400}
                                            sx={{ fontFamily: "Poppins", color: "#585857" }}
                                        >
                                            {getMonthName(ingreso?.ultimo_mes_ingresado?.month)} {ingreso?.ultimo_mes_ingresado?.year}

                                        </Typography>
        
                                        <Typography
                                            variant="h6"
                                            fontWeight={500}
                                            sx={{ fontFamily: "Poppins", color: "#585857" }}
                                        >
                                            Total{" "}
                                            <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                                ${Number(ingreso?.total_mes || 0).toLocaleString("es-CL")}
                                            </Box>
                                        </Typography>
                                    </Box>
        
                                    <Box>
                                        <GiMoneyStack size={60} color="#5cd09aff" />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box mt={5} mb={5}>
                         
                                <Typography
                                    variant="body1"
                                    fontWeight={500}
                                    sx={{ fontFamily: "Poppins", mb: 3, color: "#2a8d74" }}
                                >
                                    Reporte financiero por sucursal — {getMonthName(ingreso?.ultimo_mes_ingresado?.month)} {ingreso?.ultimo_mes_ingresado?.year}

                                  
                                </Typography>
                            
        
                           <Grid container spacing={3}>
  {ingreso?.totales_por_sucursal?.map((item) => (
    <Grid key={item.branch_id} size={{ xs: 12, sm: 6, md: 4 }}>
      <Card
        sx={{
          width: "100%",
          backgroundColor: "#ffffff",
          borderRadius: 3,
          boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
          transition: "transform 0.2s, box-shadow 0.2s",
          "&:hover": {
            transform: "scale(1.02)",
            boxShadow: "0px 6px 14px rgba(42, 103, 69, 0.5)",
          },
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "80%",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography
              variant="body1"
              fontWeight={500}
              sx={{ fontFamily: "Poppins", color: "#2a8d74" }}
            >
              {item.branch?.name}
               {obtenerNombreSucursal(item.branch_id)}
            </Typography>


            <Typography
              variant="body1"
              fontWeight={500}
              sx={{ fontFamily: "Poppins", color: "#585857" }}
            >
              Total{" "}
              <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                ${Number(item.total_sucursal).toLocaleString("es-CL")}
              </Box>
            </Typography>
          </Box>

          <GiMoneyStack size={50} color="#5cd09aff" />
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>

                        </Box>
        {/* Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
         <Tabs
    value={tab}
    onChange={handleChange}
    textColor="primary"
    indicatorColor="primary"
    variant="scrollable"   // 👈 evita que se estiren a todo el ancho
    scrollButtons={false}  // 👈 sin botones de scroll
   TabIndicatorProps={{
                            style: {
                                backgroundColor: "#6fd385ff", // 👈 mismo verde del tab activo
                                height: "3px",             // 👈 grosor de la línea
                                borderRadius: "2px",       // 👈 opcional, línea más suave
                            },
                        }}
                        sx={{
                            "& .MuiTab-root": {
                                minWidth: "auto",
                                px: 2,
                                margin: '0px 5px',
                                backgroundColor: "#b2e9be68",
                                textTransform: "none",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                borderRadius: "8px 8px 0 0", // 👈 esquinas redondeadas arriba (opcional)
                            },
                            "& .Mui-selected": {
                                backgroundColor: "#2a8d74", // 👈 verde oscuro
                                color: "#fff !important",   // 👈 letras blancas
                            },
                      
    }}
  >
            <Tab label="Ingresos" />
            <Tab label="Registro mensual" />
            
             <Tab label="Tipos ingresos" />
          </Tabs>
        </Box>

        {/* Contenido de cada tab con borde */}
        <Paper
          elevation={0}
          sx={{
            border: "1px solid #faf7f7ff",
            borderRadius: 2,
            p: 5,
            height:'auto',
            mt:'-25px'
          }}
        >
          {tab === 0 && (
            <Box>
              <Typography
                variant="h6"
                sx={{ fontFamily: "Poppins", mb: 2, color: "#585857" }}
              >
                Ingresos Totales
              </Typography>
              <IncomesTable refresh={refresh} />
            </Box>
          )}

          {tab === 1 && (
            <Box>
              <Typography
                variant="h6"
                sx={{ fontFamily: "Poppins", mb: 2, color: "#585857" }}
              >
               Ingresos Mensuales
              </Typography>
             <BuscadorIncome/>
            </Box>
          )}

         
           {tab === 2 && (
            <Box>
              <Typography
                variant="h6"
                sx={{ fontFamily: "Poppins", mb: 2, color: "#585857" }}
              >
                Tipos de Ingresos
               <TipodeIngresos/>
              </Typography>
            </Box>
          )}
        </Paper>
        </Paper>
      </Container>
    </section>
  );
}

export default IncomesIndex;